/** SheetContent className shared by the account-connection side sheets (connect, fee consent, relink, desk). */
export const ACCOUNT_CONNECTION_SHEET_CLASS =
  'menu-surface w-[min(100vw,420px)] overflow-x-hidden overflow-y-auto p-5 sm:max-w-105'

/** Dashed placeholder box for a subaccount/desk picker with nothing to list. */
export const ACCOUNT_CONNECTION_EMPTY_CLASS =
  'border border-dashed border-foreground/10 p-4 text-center text-sm text-foreground/50'
